import $ from "jquery";
import plugin from "@core/plugins/lib";

const ELEMENT_SELECTOR = '[data-video-block]';
const PLUGIN_NAME = 'VideoBlock';

$(() => {

	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "video-block" */ "./video-block"
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});

});



// WEBPACK FOOTER //
// ./client/src/core/components/video-block/plugin--split.js